var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_4715_4797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.0014 0C47.5617 0 61.002 13.4403 61.002 30.0006C61.002 46.5609 47.5617 60.0012 31.0014 60.0012C14.441 60.0012 1.00075 46.5609 1.00075 30.0006C1.00075 13.4403 14.441 0 31.0014 0ZM31.0014 48.001C33.2014 48.001 35.0014 46.2009 35.0014 44.0009C35.0014 41.8008 33.2014 40.0008 31.0014 40.0008C28.8013 40.0008 27.0013 41.8008 27.0013 44.0009C27.0013 46.2009 28.8013 48.001 31.0014 48.001ZM26.4213 16.9803L27.7613 33.0207C27.9013 34.7007 29.3013 36.0007 31.0014 36.0007C32.7014 36.0007 34.1014 34.7007 34.2414 33.0207L35.5814 16.9803C35.8014 14.3003 33.7014 12.0002 31.0014 12.0002C28.4413 12.0002 26.4013 14.0803 26.4013 16.6003C26.4013 16.7203 26.4013 16.8603 26.4213 16.9803Z",
    fill: "#FEA500"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4715_4797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.1315,
    height: 61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertYellow);
export default __webpack_public_path__ + "static/media/alert_yellow.72899854a2ed52cb87f729465dc7d5ae.svg";
export { ForwardRef as ReactComponent };